/**
     * @desc 更新NFT作品
NFT作品currentStatus=1时（已铸造），不允许更新
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/item/updateItem', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/item/updateItem', params);
}
